;$(function () {
    // 상품구좌(수동구좌): 프로모션 상품 Template
    // prettier-ignore
    var promotionProductTemplate =
        '{{#each (item, idx) in promotionProductList}}' +
            '<div class="swiper-slide">' +
                '<div class="card-inner">' +
                    '<div class="card-inner2">' +
                        '<span class="card-left">' +
                            '<a href="{{item.modelUrlPath}}" class="card-image">' +
                                '<img src="{{item.smallImageAddr}}" class="mo" alt="">' +
                            '</a>' +
                        '</span>' +
                        '<span class="card-right">' +
                            // <!--span class="card-right-top">
                            //                             <em class="badge new">신제품</em>
                            //                             <em class="badge">판매 예정</em>
                            //                         </span-->
                            '<a href="{{item.modelUrlPath}}" class="card-main-title">' +
                                '{{#raw item.modelDisplayName}}' +
                                '<span class="sub-text-new">' +
                                    '{{#if item.modelAttrTxt1}}' +
                                        '<em class="sub">{{item.modelAttrTxt1}}</em>' +
                                    '{{/if}}' +
                                    '{{#if item.modelAttrTxt2}}' +
                                        '<em class="sub">{{item.modelAttrTxt2}}</em>' +
                                    '{{/if}}' +
                                '</span>' +
                            '</a>' +
                            '<span class="card-sub-title">{{item.modelName}}</span>' +
                            '<span class="card-price">' +
                            '{{#if item.memberDiscountRate}}' +
                                '<em class="sale-count"><i>{{item.memberDiscountRate}}</i>%</em>' +
                            '{{/if}}' +
                                '<em class="price"><i>{{vcui.comma(item.obsSellingPrice)}}</i>원</em>' +
                                // '<em class="subtext true-price"><i>429,000</i>원</em>' +
                            '</span>' +
                            '{{#if item.obsLastBenefitPrice > 0 && item.obsLastBenefitPrice < item.obsSellingPrice}}' +
                                '<span class="max-reward">' +
                                    '<em class="text">최대혜택가</em>' +
                                    '<em class="price"><i>{{vcui.comma(item.obsLastBenefitPrice)}}</i>원</em>' +
                                '</span>' +
                            '{{/if}}' +
                        '</span>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '{{/each}}';

    // 상품구좌(베스트랭킹): 가격필터 Template
    // prettier-ignore
    var priceRangeTemplate =
        '{{#each (item, idx) in priceRangeList}}' +
            '<div class="swiper-slide" data-minprice="{{item.minPrice}}" data-maxprice="{{item.maxPrice}}">' +
                '<button type="button">{{item.text}}</button>' +
            '</div>' +
        '{{/each}}';

    // 상품구좌(베스트랭킹): 상품 Template
    // prettier-ignore
    var productTemplate =
        '{{#each (item, idx) in productList}}' +
            '<li>' +
                '<a href="{{item.modelUrlPath}}"> ' +
                    '<span class="best-product">' +
                        '<span class="best-product-thumb">' +
                            '{{#if item.lgecomOnlyFlag == "Y"}}' +
                                '<span class="lge-only right"><em>닷컴<br>ONLY</em></span>' +
                            '{{/if}}' +
                                '<img src="{{item.smallImageAddr}}" class="mo" alt="">' +
                            '</span>' +
                            '<span class="best-product-info">' +
                                '<span class="best-info-title">' +
                                    '{{#raw item.modelDisplayName}}' +
                                    '<span class="sub-text-new">' +
                                        '{{#if item.modelAttrTxt1}}' +
                                            '<em class="sub">{{item.modelAttrTxt1}}</em>' +
                                        '{{/if}}' +
                                        '{{#if item.modelAttrTxt2}}' +
                                            '<em class="sub">{{item.modelAttrTxt2}}</em>' +
                                        '{{/if}}' +
                                    '</span>' +
                                '</span>' +
                                '<span class="best-info-subtitle">{{item.modelName}}</span>' +
                                '<span class="best-info-price">' +
                                '{{#if item.memberDiscountRate}}' +
                                    '<em class="sale">{{item.memberDiscountRate}}%</em>' +
                                '{{/if}}' +
                                '<em class="price"><i>{{vcui.comma(item.obsSellingPrice)}}</i>원</em>' +
                                // '<em class="subtext true-price">490,000원</em>' +
                                '{{#if item.maxBenefitPrice > 0 && item.maxBenefitPrice < item.obsSellingPrice}}' +
                                    '<em class="subtext max-reward">' +
                                        '<em>최대혜택가</em>' +
                                        '<em>{{vcui.comma(item.maxBenefitPrice)}}</em>원' +
                                    '</em>' +
                                '{{/if}}' +
                            '</span>' +
                        '</span>' +
                    '</span>' +
                '</a>' +
            '</li>' +
        '{{/each}}';

    // PLP 소모품 영역 사용가능모델 팝업 이벤트 start
    var modelListPopupTemplate =
        '<header class="pop-header">' +
            '<h1 class="tit"><span>사용 가능한 모델</span></h1>' +
        '</header>' +
        '<section class="pop-conts">' +
            '<div class="model-information shared-model">' +
                '<div class="tit-wrap">' +
                    '<div class="input-wrap search">' +
                        '<input type="text" name="keyword" id="keyword" class="ui_input_clearbutton" placeholder="제품 모델명(코드)을 입력하세요." title="제품 모델명(코드)을 입력하세요." data-clear-button="button.btn-delete" value="">' +
                        '<button type="button" class="btn-delete"><span class="blind">검색어 삭제</span></button>' +
                        '<button type="button" class="btn-search"><span class="blind">검색</span></button>' +
                    '</div>' +
                '</div>' +
                '<div class="count">' +
                    '총 <em>{{_modelCnt}}</em>개' +
                '</div>' +
                '<div class="model-information-wrap">' +
                    '<ul class="model-information-list" {{#if _modelCnt == "0"}} style="display:none"{{/if}}>' +
                        '{{#each item in _modelList}}' +
                        '<li>{{item.MODEL}}{{#if item.PRODMODEL != null && item.PRODMODEL != ""}} ({{item.PRODMODEL}}){{/if}}</li>' +
                        '{{/each}}' +
                    '</ul>' +
                    '<div class="no-data" {{#if _modelCnt !== "0"}} style="display:none"{{/if}}>입력하신 모델과 일치하는 모델을 찾지 못했습니다.</div>' +
                '</div>' +
            '</div>' +
        '</section>' +
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';

    var KRP0007_display = {
        variable: {
            categoryId: null,
            rankingType: null,
            showPromotion: false,
            showBestRanking: false,
            swiper: {
                plpMainBannerTopSwiper: null,   // 메인 배너 A타입
                plpMainBannerSwiper: null,      // 메인 배너 B타입
                plpNewBannerSwiper1_1: null,    // 구매가이드
                plpNewBannerSwiper1_2: null,    // 상품구좌(수동구좌)
                plpNewBannerSwiper1_3: null,    // 라인업카드 PC
                plpNewBannerSwiper1_4: null,    // 라인업카드 MO
                plpNewBannerSwiper1_5: null,    // 스마트홈 라인업
                plpMainTab: null,               // 라인업카드탭
                plpBestTab: null                // 상품구좌(베스트랭킹)
            },
            lineupId: lgkorUI.getParameterByName('lineupId') || ''
        },
        el: {
            $mainBannerAWrap: null,
            $mainBannerBWrap: null,
            $mainDisposableBannerAWrap: null,
            $mainDisposableBannerBWrap: null,
            $buyGuideWrap: null,
            $promotionWrap: null,
            $bestRankingWrap: null,
            $bestRankingTop: null,
            $bestRankingMiddle: null,
            $bestRankingBottom: null,
            $lineupPcWrap: null,
            $lineupMoWrap: null,
            $lineupTabWrap: null,
            $windowBannerWrap: null
        },
        selector: {
            mainBannerAWrap: '.plp-new-section.main-banner',                            // 메인 배너
            mainBannerBWrap: '.plp-new-section.main-banner-swiper',
            mainDisposableBannerAWrap: '.plp-new-section.main-banner-swiper',           // 소모품 메인 배너
            mainDisposableBannerBWrap: '.plp-new-section.main-banner-swiper',
            buyGuideWrap: '.plp-new-section.small-banner',                              // 구매가이드
            promotionWrap: '.plp-new-section.small-banner-card',                        // 프로모션
            bestRankingWrap: '.plp-new-section.plp-small-banner-best',                  // 베스트랭킹
            bestRankingTop: '.plp-new-section.plp-small-banner-best .best-top',
            bestRankingMiddle: '.plp-new-section.plp-small-banner-best .best-middle',
            bestRankingBottom: '.plp-new-section.plp-small-banner-best .best-bottom',
            lineupPcWrap: '.plp-new-section.category-list.pc',                          // 라인업 카드
            lineupMoWrap: '.plp-new-section.category-list.mo',
            lineupTabWrap: '.plp-new-section.main-banner-tab',                          // 라인업 카드 탭
            lineupTabButton: '.main-banner-tab-manu .swiper-slide',
            lineupTab: '.main-banner-tab-card .tab',
            windowBannerWrap: '.plp-new-section.windows-banner'
        },
        handler: {
            priceRangeClickHandler: function(e) {
                var $this = $(e.currentTarget);

                $(".best-tab-manu .swiper-slide").removeClass("active");
                $this.addClass("active");

                this.retrieveBestRankingList();
            },
            lineupClickHandler: function(e) {
                e.preventDefault();
                this.setLineupId($(e.currentTarget).data('lineup-id'), true);
                this.showLineupTab();
            },
            lineupTabClickHandler: function(e) {
                // BTOCSITE-58721 plp 키오스크 대응  - 라인업 키오스크 구분자 추가(20240306)
                var kioskYn = $(e.currentTarget).data('kiosk-value');
                var location_path = window.location.pathname + '?lineupId=' + $(e.currentTarget).data('lineup-id');

                if(kioskYn && kioskYn != '' && kioskYn.toUpperCase() == 'Y'){
                    location_path = location_path+"&kiosk=y";
                }

                window.location.href = location_path;
                return false;
                // var $this = $(e.currentTarget);
                // var idx = $this.index();
                //
                // $(this.selector.lineupTabButton).removeClass("active");
                // $this.addClass("active");
                //
                // $(this.selector.lineupTab).hide();
                // $(this.selector.lineupTab).eq(idx).show();
                //
                // this.resizeEvPlp();
                // this.setLineupId($this.data('lineup-id'), true);
            },
            popStateHandler: function(e) {
                var lineupId = lgkorUI.getParameterByName('lineupId');
                if (lineupId) {
                    this.setLineupId(lineupId, false);
                    this.showLineupTab();
                } else {
                    this.setLineupId('', false);
                    this.showLineupTab(false);
                }
            },
            compatibleModelClickHandler: function(e) {
                e.preventDefault();
                var modelId = $(e.currentTarget).closest(".card-list-item.normal-card").attr("data-model-id");

                //s: BTOCSITE-61874 [PLP] 소모품 임직원 판매 - 버그 수정
                var compatibleModelYn = $(e.currentTarget).closest(".card-list-item.normal-card").attr("data-compatible-model-yn");
                if(compatibleModelYn != 'Y'){
                    return;
                }
                //e: BTOCSITE-61874 [PLP] 소모품 임직원 판매 - 버그 수정

                if ($("#popupSharedModel").attr("data-model-id") === "" || $("#popupSharedModel").attr("data-model-id") !== modelId) {
                    this.requestCompatibleModel(e);
                } else {
                    $("#popupSharedModel").vcModal("show");
                }
            }
        },
        init: function () {
            this.settings();
            this.bindEvents();
            this.initSwiper();

            // BTOCSITE-71779 [PC] 필터 내용은 5회 중복됩니다. 체크박스를 클릭하면 자동으로 모두 선택됨 START
            if ($('.product-list-area').find('.card-list-item').length === 0 && $('input[id=sub_category_tab_0]').length > 0) {
                window.location.href = $('input[id=sub_category_tab_0]').data('category-url-path');
            }
            // BTOCSITE-71779 [PC] 필터 내용은 5회 중복됩니다. 체크박스를 클릭하면 자동으로 모두 선택됨 END

            if (this.variable.showPromotion) {
                this.retrievePromotionProductList();
            }

            if (this.variable.showBestRanking) {
                this.retrieveBestRankingList();
                this.retrievePriceRangeList();
            }

            this.checkTooltip();

            // BTOCSITE-75547 START
            if ($(window).width() < 360) {
                $('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
            }
            // BTOCSITE-75547 END

            /* 퍼블 영역 START */
            // if ($('.main-banner-inner').length) {           // 메인배너 A타입
            //     this.resizeEvMainBanner();
            // }
            if ($('.plp-main-banner-swiper')) {      // 메인배너 B타입
                this.resizeArr1();
            }
            if ($('.pc .plp-category-swiper')) {
                this.resizeArr2();
            }
            if ($('.smart-lineup .plp-category-swiper')) { // 스마트홈 라인업
                this.resizeArr3();
            }
            if ($('.plp-new-main-banner-tab')) {     // 라인업카드 탭
                this.resizeEvPlp();
            }
            this.tabContentCheck();
            /* 퍼블 영역 END */
        },
        settings: function () {
            this.el.$mainBannerAWrap = $(this.selector.mainBannerAWrap);
            this.el.$mainBannerBWrap = $(this.selector.mainBannerBWrap);
            this.el.$mainDisposableBannerAWrap = $(this.selector.mainDisposableBannerAWrap);
            this.el.$mainDisposableBannerBWrap = $(this.selector.mainDisposableBannerBWrap);
            this.el.$buyGuideWrap = $(this.selector.buyGuideWrap);
            this.el.$promotionWrap = $(this.selector.promotionWrap);
            this.el.$bestRankingWrap = $(this.selector.bestRankingWrap);
            this.el.$bestRankingTop = $(this.selector.bestRankingTop);
            this.el.$bestRankingMiddle = $(this.selector.bestRankingMiddle);
            this.el.$bestRankingBottom = $(this.selector.bestRankingBottom);
            this.el.$lineupPcWrap = $(this.selector.lineupPcWrap);
            this.el.$lineupMoWrap = $(this.selector.lineupMoWrap);
            this.el.$lineupTabWrap = $(this.selector.lineupTabWrap);
            this.el.$windowBannerWrap = $(this.selector.windowBannerWrap);

            this.variable.categoryId = lgkorUI.getHiddenInputData().categoryId;
            this.variable.rankingType = 'todays';
            this.variable.showPromotion = ($(this.selector.promotionWrap).length > 0);
            this.variable.showBestRanking = ($(this.selector.bestRankingWrap).length > 0);
        },
        bindEvents: function () {
            var self = this;

            $(".best-tab-manu .swiper-wrapper").on("click", ".swiper-slide", $.proxy(self.handler.priceRangeClickHandler, self));    // 베스트랭킹 가격 범위 버튼
            //self.el.$lineupPcWrap.find('.swiper-slide').on("click", $.proxy(self.handler.lineupClickHandler, self));                 // 라인업카드 클릭 PC
            //self.el.$lineupMoWrap.find('.swiper-slide li').on("click", $.proxy(self.handler.lineupClickHandler, self));              // 라인업카드 클릭 MO
            $(self.selector.lineupTabButton).on("click", $.proxy(self.handler.lineupTabClickHandler, self));                         // 라인업카드 탭 버튼
            //$(window).on("popstate", $.proxy(self.handler.popStateHandler, self));                                                   // 뒤로가기
            $('.product-list-area').on('click', '.enable-count', $.proxy(self.handler.compatibleModelClickHandler, self));                          // 소모품 > 사용 가능한 모델 팝업
            $(document).on("input", ".shared-model .ui_input_clearbutton", self.inputPopShareModel);                                 // 소모품 > 사용 가능한 모델 팝업: 모델명 검색
            $(document).on("click", '.tooltip-container .close', function() {
                var id = $(this).parent().attr('id');
                if (id) {
                    var value = {};
                    value[id] = 'closed';
                    lgkorUI.setStorage('tooltipState', value, true);
                }
            });
            
            /* 퍼블 영역 START */
            // if ($('.main-banner-inner')) {
            //     $(window).on("resize", self.resizeEvMainBanner());
            // }
            if ($('.plp-main-banner-swiper')) {
                $(window).on("resize", self.resizeArr1);
            }
            if ($('.pc .plp-category-swiper')) {
                $(window).on("resize", self.resizeArr2);
            }
            if ($('.smart-lineup .plp-category-swiper')) {
                $(window).on("resize", self.resizeArr3);
            }
            if ($('.plp-new-main-banner-tab')) {
                $(window).on("resize", self.resizeEvPlp);
            }
            $(window).on('load', self.plpLoadingCheck);
            /* 퍼블 영역 END */

        },
        initSwiper: function() {
            // 메인배너 A타입
            if ($('.main-banner-inner .swiper-slide').length) {
                if ($('.main-banner-inner .swiper-wrapper').children().length > 1) {
                    // var plpMainBannerTopSwiper = new Swiper(".main-banner-inner", {
                    this.variable.plpMainBannerTopSwiper = new Swiper(".main-banner-inner", {
                        slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                        centeredSlides: false,    //센터모드
                        loop: true,   // 슬라이드 반복 여부
                        loopAdditionalSlides: 1,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        pagination: {
                            el: '.main-banner-inner .plp-category-navi',
                            clickable: true,
                            type: 'bullets',
                        },
                    });
                }
            }
            // 메인배너 B타입
            if ($('.plp-main-banner-swiper .swiper-slide').length) {
                // var swiperTopNum = $('.plp-main-banner-swiper').find('.swiper-slide');
                // var swiperSubNum = $('.plp-main-banner-sub-swiper').find('.plp-main-banner-sub-swiper');
                // var plpMainBannerSwiper = new Swiper(".plp-main-banner-swiper", {
                var plpMainBannerSwiperOptions = {
                    slidesPerView: 'auto',
                    loopAdditionalSlides: 1,
                    autoHeight: false,
                    autoplaySpeed: 5000,
                    navigation: {
                        nextEl: '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-right', // 다음 버튼 클래스명
                        prevEl: '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-left', // 이번 버튼 클래스명
                    },
                    pagination: {
                        el: '.plp-main-banner-swiper-outer .plp-category-navi',
                        clickable: true,
                        type: 'bullets',
                    },
                    breakpoints: {
                        1024: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                        },
                    },
                };

                if ($(window).width() >= 1024 && $('.plp-main-banner-swiper .swiper-wrapper').children().length > 2) {
                    $('.plp-main-banner-swiper').parent().addClass('is-swipe');
                    plpMainBannerSwiperOptions.loop = true;
                    plpMainBannerSwiperOptions.autoplay = true;
                    plpMainBannerSwiperOptions.navigation.nextEl = '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-right';
                    plpMainBannerSwiperOptions.navigation.prevEl = '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-left';
                } else if ($(window).width() < 1024 && $('.plp-main-banner-swiper .swiper-wrapper').children().length > 1) {
                    plpMainBannerSwiperOptions.loop = true;
                    plpMainBannerSwiperOptions.autoplay = true;
                }
                
                if ($('.plp-main-banner-swiper .swiper-wrapper').children().length > 1) {
                    var plpMainBannerSwiper = new Swiper(".plp-main-banner-swiper", plpMainBannerSwiperOptions);
                } else {
                    $('.plp-main-banner-swiper').parent().addClass('is-single');
                }
            }
            // 구매가이드
            if ($('.plp-small-banner-swiper .swiper-slide').length) {
                if ($('.plp-small-banner-swiper .swiper-wrapper').children().length > 1) {
                    // var plpNewBannerSwiper1_1 = new Swiper(".plp-small-banner-swiper-inner", {
                    this.variable.plpNewBannerSwiper1_1 = new Swiper(".plp-small-banner-swiper-inner", {
                        spaceBetween: 10,    // 슬라이드 사이 여백
                        slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                        centeredSlides: false,    //센터모드
                        loop: false,   // 슬라이드 반복 여부
                        loopAdditionalSlides: 1,
                        navigation: {
                            nextEl: '.small-banner-swiper-arrow .right', // 다음 버튼 클래스명
                            prevEl: '.small-banner-swiper-arrow .left', // 이번 버튼 클래스명
                        },
                    });
                } else {
                    $('.plp-small-banner-swiper').parent().addClass('is-single');
                }
            }
            // 라인업 카드 PC
            if ($('.pc .plp-category-swiper').length) {
                if ($('.pc .plp-category-swiper .swiper-wrapper').children().length > 1) {
                    if($(".pc .plp-category-swiper").find(".swiper-slide").length == 2) {
                        $(".plp-new-section.category-list.pc").addClass("length2");
                    }
                    else if($(".pc .plp-category-swiper").find(".swiper-slide").length == 3) {
                        $(".plp-new-section.category-list.pc").addClass("length3");
                    }
                    else if($(".pc .plp-category-swiper").find(".swiper-slide").length == 4) {
                        $(".plp-new-section.category-list.pc").addClass("length4");
                    }
                    // var plpNewBannerSwiper1_1 = new Swiper(".pc .plp-category-swiper", {
                    this.variable.plpNewBannerSwiper1_3 = new Swiper(".pc .plp-category-swiper", {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        centeredSlides: false,    //센터모드
                        loop: false,   // 슬라이드 반복 여부
                        loopAdditionalSlides: 1,
                        parallax:true,
                        /*
                        pagination: {
                            el: '.category-list.pc .plp-category-navi',
                            clickable: true,
                            type: 'bullets',
                        },
                        */
                        breakpoints: {
                            1024: {
                                spaceBetween: 33,    // 슬라이드 사이 여백
                                slidesPerView: 5, // 한 슬라이드에 보여줄 갯수
                            },
                        },
                        navigation: {
                            nextEl: '.category-list.pc .carousel-navi-type-arrow.pc .sel-right', // 다음 버튼 클래스명
                            prevEl: '.category-list.pc .carousel-navi-type-arrow.pc .sel-left', // 이번 버튼 클래스명
                        },
                    });
                }
                else {
                    $('.pc .plp-category-swiper').parent().addClass('is-single');
                }
            }
            // 스마트홈 라인업
            if ($('.smart-lineup .plp-category-swiper').length) {
                if ($('.smart-lineup .plp-category-swiper .swiper-wrapper').children().length > 1) {
                    if($(".smart-lineup .plp-category-swiper").find(".swiper-slide").length == 2) {
                        $(".plp-new-section.smart-lineup").addClass("length2");
                        $(".smart-lineup .carousel-navi-type-arrow").hide();
                    }
                    else if($(".smart-lineup .plp-category-swiper").find(".swiper-slide").length == 3) {
                        $(".plp-new-section.smart-lineup").addClass("length3");
                        $(".smart-lineup .carousel-navi-type-arrow").hide();
                    }
                    else if($(".smart-lineup .plp-category-swiper").find(".swiper-slide").length == 4) {
                        $(".plp-new-section.smart-lineup").addClass("length4");
                        $(".smart-lineup .carousel-navi-type-arrow").hide();
                    }
                    this.variable.plpNewBannerSwiper1_5 = new Swiper(".smart-lineup .plp-category-swiper", {
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                        centeredSlides: false,    //센터모드
                        loop: false,   // 슬라이드 반복 여부
                        loopAdditionalSlides: 1,
                        parallax:true,
                        breakpoints: {
                            1024: {
                                spaceBetween: 24,    // 슬라이드 사이 여백
                                slidesPerView:4, // 한 슬라이드에 보여줄 갯수
                            },
                        },
                        navigation: {
                        nextEl: '.smart-lineup .carousel-navi-type-arrow .sel-right', // 다음 버튼 클래스명
                        prevEl: '.smart-lineup .carousel-navi-type-arrow .sel-left', // 이번 버튼 클래스명
                        },
                    });
                }
                else{
                    $('.smart-lineup .plp-category-swiper').parent().addClass('is-single');
                }
            }
            // 라인업 카드 MO
            if ($('.mo .plp-category-swiper .swiper-slide').length) {
                if ($('.mo .plp-category-swiper .swiper-wrapper').children().length > 1) {
                    // var plpNewBannerSwiper1_1 = new Swiper(".mo .plp-category-swiper", {
                    this.variable.plpNewBannerSwiper1_4 = new Swiper(".mo .plp-category-swiper", {
                        spaceBetween: 10,    // 슬라이드 사이 여백
                        slidesPerView: '1', // 한 슬라이드에 보여줄 갯수
                        centeredSlides: false,    //센터모드
                        loop: false,   // 슬라이드 반복 여부
                        loopAdditionalSlides: 1,
                        pagination: {
                            el: '.plp-category-swiper .plp-category-navi',
                            clickable: true,
                            type: 'bullets',
                        },
                    });
                } else {
                    $('.mo .plp-category-swiper').parent().addClass('is-single');
                }
            }
            // 라인업 카드 탭
            if ($('.main-banner-tab-manu .swiper-slide').length) {
                // var plpMainTab = new Swiper(".main-banner-tab-manu", {
                this.variable.plpMainTab = new Swiper(".main-banner-tab-manu", {
                    spaceBetween: 8,    // 슬라이드 사이 여백
                    slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                    centeredSlides: false,    //센터모드
                    loop: false,   // 슬라이드 반복 여부
                    loopAdditionalSlides: 1,
                    parallax:true,
                    on: {
                        afterInit: function (e) {
                            var $tabMenu = $('.main-banner-tab-manu');
                            var lineUpSwiper = e;
                            lineUpSwiper.on('click', function(e){
                                $tabMenu.find('.swiper-slide').removeClass('active');
                                $(e.clickedSlide).addClass('active');
                            });
                            setTimeout(function(){
                                var current = $tabMenu.find('.swiper-slide.active').index();
                                console.log('current :: '+current);
                                lineUpSwiper.slideTo(current, 0);
                                $tabMenu.css('visibility','visible');
                            },20);
                        },
                    },
                });
            }
            // 베스트랭킹
            if ($('.best-tab-manu .swiper-slide').length) {
                // var plpBestTab = new Swiper(".best-tab-manu", {
                this.variable.plpBestTab = new Swiper(".best-tab-manu", {
                    spaceBetween: 4,    // 슬라이드 사이 여백
                    slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                    centeredSlides: false,    //센터모드
                    loop: false,   // 슬라이드 반복 여부
                    loopAdditionalSlides: 1,
                    breakpoints: {
                        1024: {
                            spaceBetween: 8,
                        },
                    },
                });
            }
        },
        retrievePromotionProductList: function () {
            var self = this;
            var sendUrl = "/item/plp/retrievePromotionProductList.lgajax";
            var requestData = {
                categoryId: self.variable.categoryId
            };

            lgkorUI.requestAjaxData(sendUrl, requestData, function (result) {
                if (result.data[0].promotion.promotionProductList != null && result.data[0].promotion.promotionProductList.length > 0) {
                    var promotionProductList = result.data[0].promotion.promotionProductList;
                    promotionProductList.forEach(function(v, i) {
                        // 속성 값 설정
                        if (v.modelAttrTxt) {
                            v.modelAttrTxt1 = v.modelAttrTxt.split('^')[0];
                            v.modelAttrTxt2 = v.modelAttrTxt.split('^')[1];
                        }
                        // 할인율
                        v.memberDiscountRate = Math.floor(((v.obsOriginalPrice - v.obsSellingPrice) / v.obsOriginalPrice) * 100);

                    });
                    self.el.$promotionWrap.find('.swiper-wrapper')
                        .empty()
                        .append(vcui.template(promotionProductTemplate, {promotionProductList: promotionProductList}));
                    if (self.variable.swiper.plpNewBannerSwiper1_2) {
                        self.variable.swiper.plpNewBannerSwiper1_2.update();
                    } else {
                        // 프로모션 swiper
                        if ($('.plp-small-banner-card-swiper .swiper-slide').length) {
                            if ($('.plp-small-banner-card-swiper .swiper-wrapper').children().length > 1) {
                                // var plpNewBannerSwiper1_2 = new Swiper(".plp-small-banner-card-swiper-inner", {
                                self.variable.plpNewBannerSwiper1_2 = new Swiper(".plp-small-banner-card-swiper-inner", {
                                    spaceBetween: 10,    // 슬라이드 사이 여백
                                    slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                                    centeredSlides: false,    //센터모드
                                    loop: false,   // 슬라이드 반복 여부
                                    loopAdditionalSlides: 1,
                                    breakpoints: {
                                        1024: {
                                            slidesPerView: 2,
                                            spaceBetween: 32,
                                        },
                                    },
                                    pagination: {
                                        el: '.plp-small-banner-card-swiper .plp-category-navi',
                                        clickable: true,
                                        type: 'bullets',
                                    },
                                });
                            } else {
                                $('.plp-small-banner-card-swiper').parent().addClass('is-single');
                            }
                        }
                    }
                } else {
                    self.el.$promotionWrap.hide();
                }

            }, "POST", "json");
        },
        retrievePriceRangeList: function () {
            var self = this;
            var param = {
                rankingType: self.variable.rankingType,
                categoryId: self.variable.categoryId
            }
            var sendUrl = "/item/plp/retrieveBestRankingPriceRangeList.lgajax";

            lgkorUI.requestAjaxData(sendUrl, param, function (result) {
                var priceRangeList = [];
                if (result.data[0].bestRankingPriceRangeList != null && result.data[0].bestRankingPriceRangeList.length > 0) {
                    result.data[0].bestRankingPriceRangeList.forEach(function (item, index) {
                        if (item.prdCnt > 4) {
                            priceRangeList.push(item);
                        }
                    });

                    if (priceRangeList.length > 0) {
                        self.el.$bestRankingMiddle.find('.swiper-wrapper')
                            .empty()
                            .append(vcui.template(priceRangeTemplate, {priceRangeList: priceRangeList}));
                        if (!self.variable.lineupId)    // 활성화된 라인업이 없으면
                            self.el.$promotionWrap.show();
                        if (self.variable.swiper.plpBestTab)
                            self.variable.swiper.plpBestTab.update();
                    }
                }
            }, "POST", "json");
        },
        retrieveBestRankingList: function () {
            var self = this;
            var sendUrl = "/item/plp/retrieveBestRankingProductList.lgajax";
            var requestData = {
                rankingType: self.variable.rankingType,
                categoryId: self.variable.categoryId,
                minPrice: $(".best-tab-manu .swiper-slide.active").data('minprice'),
                maxPrice: $(".best-tab-manu .swiper-slide.active").data('maxprice')
            };

            lgkorUI.requestAjaxData(sendUrl, requestData, function (result) {
                if (result.data[0].bestRankingProductList != null && result.data[0].bestRankingProductList.length > 0) {
                    var bestRankingProductList = result.data[0].bestRankingProductList;
                    bestRankingProductList.forEach(function(v, i) {
                        if (v.modelAttrTxt) {
                            v.modelAttrTxt1 = v.modelAttrTxt.split('^')[0];
                            v.modelAttrTxt2 = v.modelAttrTxt.split('^')[1];
                        }
                        // 할인율
                        //v.memberDiscountRate = Math.floor(((v.obsOriginalPrice - v.obsSellingPrice) / v.obsOriginalPrice) * 100);
                    });
                    self.el.$bestRankingBottom.find('.best-list > ul')
                        .empty()
                        .append(vcui.template(productTemplate, {productList: bestRankingProductList}));
                    if (!self.variable.lineupId)
                        self.el.$bestRankingWrap.show();
                } else {
                    self.el.$bestRankingWrap.hide();
                }
            }, "POST", "json");
        },
        showLineupTab: function(flag) {
            flag = (typeof flag === 'undefined' ? true : flag);
            if (flag) {
                var self = this;

                self.el.$mainBannerAWrap.hide();
                self.el.$mainBannerBWrap.hide();
                self.el.$mainDisposableBannerAWrap.hide();
                self.el.$mainDisposableBannerBWrap.hide();
                self.el.$buyGuideWrap.hide();
                self.el.$promotionWrap.hide();
                self.el.$bestRankingWrap.hide();
                self.el.$lineupPcWrap.hide();
                self.el.$lineupMoWrap.hide();
                if (self.el.$windowBannerWrap.length)
                    self.el.$windowBannerWrap.hide();

                self.updateLineupTab();
                $('.cate-list').hide().parent().parent().css('height', '');
                self.el.$lineupTabWrap.show();
                $("html, body").animate({scrollTop: self.el.$lineupTabWrap.offset().top}, 0);
            } else {
                var self = this;

                self.el.$mainBannerAWrap.show();
                self.el.$mainBannerBWrap.show();
                self.el.$mainDisposableBannerAWrap.show();
                self.el.$mainDisposableBannerBWrap.show();
                self.el.$buyGuideWrap.show();
                if ($('.plp-small-banner-card-swiper .swiper-slide').length) {
                    self.el.$promotionWrap.show();
                }
                if ($('.plp-small-banner-best .swiper-slide').length && $('.plp-small-banner-best .best-list li').length) {
                    self.el.$bestRankingWrap.show();
                }
                self.el.$lineupPcWrap.css("display", "");
                self.el.$lineupMoWrap.css("display", "");
                if (self.el.$windowBannerWrap.length)
                    self.el.$windowBannerWrap.show();
                $('.cate-list').show();
                self.el.$lineupTabWrap.hide();
            }

            self.resizeEvPlp();
        },
        /**
         * this.variable.lineupId에 맞는 라인업 탭을 선택
         */
        updateLineupTab: function() {
            var self = this;
            if (!self.variable.lineupId) return;

            $(self.selector.lineupTabButton).removeClass("active");
            $(self.selector.lineupTab).hide();
            $(self.selector.lineupTabButton).each(function(index, item) {
                if ($(item).data('lineup-id') === self.variable.lineupId) {
                    $(item).addClass("active");
                    $(item).focus();
                    $(self.selector.lineupTab).eq(index).show();

                    return false;
                }
            });
        },
        setLineupId(lineupId, historyPushFlag) {
            console.log('setLineupId called!!');
            if (lineupId === this.variable.lineupId) return;

            this.variable.lineupId = lineupId;

            lgkorUI.setHiddenInputData({
                lineupId: lineupId,
                subCategoryId: '',
                redrawFilterFlag: 'Y',
                page: 1
            });

            $('.btn-refresh').trigger('click');

            if (historyPushFlag) {
                //history.pushState({}, "", vcui.uri.updateQueryParam(location.href, 'lineupId', lineupId));
				history.replaceState({}, "", vcui.uri.updateQueryParam(location.href, 'lineupId', lineupId));
            }

            $(window).trigger('plpFilter.change');
        },

        /* 소모품 사용가능모델 START */
        /**
         * @method requestCompatibleModel
         * @return {myCallback}  [소모품 > 적용 가능 모델 리스트 팝업]
         */
        requestCompatibleModel: function(e) {
            // var ajaxUrl = this.el.$contents.attr("data-compatible-model-list");
            var ajaxUrl = $(".component.KRP0007").attr("data-compatible-model-list");
            var $item = $(e.currentTarget).closest(".card-list-item.normal-card");

            var data = {
                bizType: 'DISPOSABLE',
                modelId: $item.attr("data-model-id")
            };

            // this.variable.compatibleModelList = [];

            $("#popupSharedModel").attr("data-model-id", data.modelId);

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                data,
                function (result) {
                    if (result.status.toUpperCase() === "SUCCESS") {
                        // this.variable.compatibleModelList = result.data[0].compatibleModels;
                        this.renderModelPop(result.data[0].compatibleModels);
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method renderModelPop
         * @return {myCallback}  [소모품 카테고리 > 적용 가능 모델 리스트 팝업 html append]
         */
        renderModelPop: function(compatibleModels) {
            var data = {};
            // data._modelList = this.variable.compatibleModelList;
            data._modelList = compatibleModels;
            data._modelCnt = data._modelList.length;

            $("#popupSharedModel").html(vcui.template(modelListPopupTemplate, data));

            $("#popupSharedModel").vcModal("show");
        },
        /**
         * @callback inputPopShareModel
         * @param {e}
         * @return {myCallback} [소모품 > 사용 가능한 모델 팝업 : 모델명 검색]
         */
        inputPopShareModel: function(e) {
            var keyword = $(e.currentTarget).val().toUpperCase().trim();

            var regex = /[^a-zA-Z0-9.\-]/g;

            if (regex.test(keyword)) {
                $(e.currentTarget).val(keyword.replace(regex, ""));
                return;
            }

            var $list = $(e.currentTarget).parents(".model-information").find(".model-information-list");
            var $listItem = $list.find("li");
            var $nodata = $("#popupSharedModel .no-data");
            var $count = $(e.currentTarget).parents(".model-information").find(".count em");

            $listItem.hide();
            $count.html($list.find("li:contains('" + keyword + "')").length);
            $list.find("li:contains('" + keyword + "')").show();

            if (keyword == "") {
                $list.show();
                $nodata.hide();
            } else {
                if (!$list.find("li:contains('" + keyword + "')").length) {
                    $list.hide();
                    $nodata.show();
                } else {
                    $list.show();
                    $nodata.hide();
                }
            }
        },
        /* 소모품 사용가능모델 END */

        // 툴팁 출력 여부
        checkTooltip: function() {
            var tooltipState = lgkorUI.getStorage('tooltipState');
            $(".tooltip-container").each(function(){
                var id = $(this).attr('id');
                if (id && tooltipState[id] != 'closed') $('#' + id).addClass('ani active');
            });
        },

        /* 퍼블 영역 START */
        resizeEvMainBanner: function() {
            $('.main-banner-background.mo').each(function () {
                var mainMathWid = $(this).outerWidth();
                var mainResizingWid = $(this).find('img').outerWidth();
                var mainMathHei = $(this).outerHeight();
                var mainResizingHei = $(this).find('img').outerHeight();
                if (mainMathHei > mainResizingHei) {
                    $('.main-banner-background.mo').removeClass('resize-w').addClass('resize-h');
                } else if (mainMathHei < mainResizingHei) {
                    $('.main-banner-background.mo').removeClass('resize-h').addClass('resize-w');
                } else if (mainMathWid > mainResizingWid) {
                    $('.main-banner-background.mo').removeClass('resize-h').addClass('resize-w');
                } else if (mainMathWid < mainResizingWid) {
                    $('.main-banner-background.mo').removeClass('resize-w').addClass('resize-h');
                }
            });
        },
        resizeArr1: function() {
            if (window.innerWidth > 1024) {
                // var mainHei1 = $(".plp-main-banner-swiper .swiper-slide").innerHeight() / 2;
                var mainHei1 = $(".plp-main-banner-swiper .swiper-slide .swiper-top").innerHeight() / 2;
                $(".main-banner-swiper .carousel-navi-type-arrow.pc").css('top', mainHei1);
            }
        },
        resizeArr2: function() {
            if (window.innerWidth > 1024) {
                var mainHei2 = $(".plp-category-swiper .img-container").innerHeight() / 2;
                $(".category-list.pc .carousel-navi-type-arrow.pc").css('top', mainHei2);
            }
        },
        resizeArr3: function() {
            if (window.innerWidth > 1024) {
                var mainHei3 = $(".plp-category-swiper .img-container").innerHeight() / 2;
                $(".smart-lineup .carousel-navi-type-arrow").css('top', mainHei3);
            }
        },
        resizeEvPlp: function() {
            var mathWid = $('.main-banner-tab-background').outerWidth();
            var resizingWid = $('.main-banner-tab-background img').outerWidth();
            var mathHei = $('.main-banner-tab-background').outerHeight();
            var resizingHei = $('.main-banner-tab-background img').outerHeight();
            if (mathHei > resizingHei) {
                $('.main-banner-tab-background').removeClass('resize-w').addClass('resize-h');
            } else if (mathHei < resizingHei) {
                $('.main-banner-tab-background').removeClass('resize-h').addClass('resize-w');
            } else if (mathWid > resizingWid) {
                $('.main-banner-tab-background').removeClass('resize-h').addClass('resize-w');
            } else if (mathWid < resizingWid) {
                $('.main-banner-tab-background').removeClass('resize-w').addClass('resize-h');
            }
        },
        tabContentCheck: function() {
            $(this.selector.lineupTab).each(function () {
                var $this = $(this);
                if ($this.find(".tab-card-bottom").length > 0) {
                    $this.addClass("is-have-bottom-content");
                }
            });
        },
        plpLoadingCheck: function() {
            $(".plp-new-section").removeClass("is-loading");
            $(".plp-new-section").removeClass("length2");
            $(".plp-new-section").removeClass("length3");
            $(".plp-new-section").removeClass("length4");
            $("body").removeClass("is-loading");
        }
        /* 퍼블 영역 END */
    };

    $(document).on('ready', function () {
        KRP0007_display.init();

        var lineupId = lgkorUI.getParameterByName('lineupId');
        if (lineupId) {
            KRP0007_display.updateLineupTab();
        }
    });

});